import { useQuery } from '@tanstack/react-query'
import { render } from '@testing-library/react'
import { Input, Table, Button, message, Select, Tag } from 'antd'
import moment from 'moment'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import ErrorModal from '@Modal/ErrorModal'
import SuccessModal from '@Modal/SuccessModal'
import { http } from '@services/http'
import { calculateKvm } from '@utils/calculateKvm'
import {
	numberWithSpacesIntl,
	roundToTwoDecimals,
} from '@utils/numberWithSpaces'

import OrderPaymentModal from '../orderPaymentModal'



const SalesInfo = ({
	data,
	onClose = () => {},
	ship = false,
	incoming = false,
	finishSale = false,
	refetch = () => {},
	visible,
	isFinishedSalesMenu = false,
	isShowStartProduction = false,
		isShowProfit = false,

}) => {
	const { t } = useTranslation()

	const employeeId = useSelector((state) => state.main.employeeId)
	const salesPersonCode = useSelector((state) => state.main.salesPersonCode)
	const { getMe } = useSelector((state) => state.main)

	const successRef = useRef()
	const errorRef = useRef()

	const [isModalVisible, setIsModalVisible] = useState(false)
	const [shipBtnLoading, setShipBtnLoading] = useState(false)
	const [dueDate, setDueDate] = useState('')
	const [deadLine, setDeadline] = useState('')
	const [itemDocLines, setItemDocLines] = useState(null)
	const [expensesDocLines, setExpensesDocLines] = useState(null)
	const [startProductionBtnLoading, setStartProductionBtnLoading] =
		useState(false)

	useEffect(() => {
		if (data?.docDate) {
			setDueDate(moment(data?.docDate).format('DD.MM.YYYY'))
			setDeadline(moment(data?.docDueDate).format('DD.MM.YYYY'))
		}
		if (data) {
			const docLines = data?.documentLines
				.filter((item) => {
					return item.u_Produkt === null
				})
				.map((item, index) => ({
					key: index,
					...item,
					itemDescription: item.itemDescription,
					quantity: item.quantity,
					price: item.price,
					lineTotal: item.lineTotal,
					whsName: item.whsName,
					u_Produkt: item.u_Produkt,
					currency: item.currency,
					openQty: item.openQty,
					width: item.u_Width,
					height: item.u_Height,
					koef: item.u_Coefficient,
					ugpCode: item.ugpCode,
					u_PlannedQuantity: item.u_PlannedQuantity,
					productions: [],
					shippingQuantity: 0,
					oneItemKvm: ((item.u_Width * item.u_Height) / 1000000) * 1,
					openQuantitySon: roundToTwoDecimals(
						item.openQty /
							(((item.u_Width * item.u_Height) / 1000000) * 1),
					),
					openQuantitySonFromData: roundToTwoDecimals(
						item.openQty /
							(((item.u_Width * item.u_Height) / 1000000) * 1),
					),
					shippedQuantity:
						+item.u_PlannedQuantity -
						+roundToTwoDecimals(
							item.openQty /
								(((item.u_Width * item.u_Height) / 1000000) *
									1),
						),
					shippedQuantityKvm: item.quantity - item.openQty,
				}))

			const expenses = data?.documentLines.filter((item) => {
				return item.u_Modal === 'Xarajatlar'
			})

			setExpensesDocLines(expenses || [])
			setItemDocLines(docLines || [])
		}
	}, [data])

	const fetchProductionsForOneSale = async ({ queryKey }) => {
		const [_, docEntry] = queryKey
		try {
			const url = `api/pots/get-pots-lines?isDelivery=true&salesOrderDocEntry=${docEntry}&skip=0&pageSize=1000`
			const { data } = await http.get(url)
			return data
		} catch (error) {
			console.log(error)
		}
	}

	const { data: productionData = [] } = useQuery({
		queryKey: ['productions', data?.docEntry, visible, data],
		queryFn: fetchProductionsForOneSale,
		keepPreviousData: false,
		refetchOnWindowFocus: true,
		enabled: !!data?.docEntry,
		refetchInterval: 60000,
	})

	const shipData = async () => {
		if (!data) return
		if (itemDocLines?.every((item) => item.productions.length <= 0)) {
			return message.error('Seria raqam tanlanmagan')
		}
		if (itemDocLines?.every((item) => item.shippingQuantity <= 0)) {
			return message.error('Ortilayotgan miqdori kiritilmagan')
		}

		const baseEntry = data?.correctionDocEntry || data.docEntry
		let currentLineNum = 0
		const getNextLineNum = () => currentLineNum++

		const documentLinesServices = data?.documentLines
			?.filter((item) => {
				if (!item.u_Produkt || item.openQty <= 0) return false

				const serviceProduct = itemDocLines?.find(
					(product) => product.lineNum == item.u_uslugaID,
				)

				return serviceProduct && serviceProduct.shippingQuantity > 0
			})
			.map((item) => {
				const serviceProduct = itemDocLines?.find(
					(product) => product.lineNum == item.u_uslugaID,
				)

				return {
					baseEntry: baseEntry,
					baseLine: item.lineNum,
					baseType: data?.correctionDocEntry ? 165 : 13,
					itemCode: item.itemCode,
					lineNum: getNextLineNum(),
					quantity:
						(item.quantity / serviceProduct.u_PlannedQuantity) *
						+serviceProduct.shippingQuantity,
					price: item.price,
					currency: item.currency,
					warehouseCode: item.warehouseCode || '',
					u_Coefficient: item.u_Coefficient,
					u_Height: item.u_Height,
					u_Width: item.u_Width,
					u_Kvmetr: item.u_Kvmetr,
					u_FigureQuantity: item.u_FigureQuantity,
					u_PlannedQuantity: serviceProduct.shippingQuantity,
																isProduct: false,
orderQuantity: item.quantity
				}
			})

		const expensesLines = expensesDocLines?.map((item) => {
			const totalSendingQty = itemDocLines?.reduce((acc, product) => {
				acc +=
					+product.shippingQuantity *
					calculateKvm(+product?.u_Width, +product?.u_Height)
				return acc
			}, 0)

			const totalShippingQty = itemDocLines?.reduce((acc, product) => {
				acc += +product.shippingQuantity
				return acc
			}, 0)
			// const totalItemQty = itemDocLines?.reduce((acc, product) => {
			// 	acc += +product.u_PlannedQuantity
			// 	return acc
			// }, 0)

			console.log(
				'totalSendingQty',
				totalSendingQty,
				'totalShippingQty',
				totalShippingQty,
				'item',
				item,
			)

			return {
				baseEntry: baseEntry,
				baseLine: item.lineNum,
				baseType: data?.correctionDocEntry ? 165 : 13,
				itemCode: item.itemCode,
				quantity:
					item?.itemCode === 'stanokk_xarajat' ||
					item?.itemCode === 'Elektr_xarajat'
						// ? totalShippingQty / item.quantity
						? totalShippingQty / item.u_PlannedQuantity // Bu logika orqaga qaytarilishi mumkun 30-iyuldigi  error uchun logika ozgartirildi
						: totalSendingQty,
				lineNum: getNextLineNum(),
				price: item.price,
				currency: item.currency,
				warehouseCode: item.warehouseCode || '',
				u_Coefficient: item.u_Coefficient,
				u_Height: item.u_Height,
				u_Width: item.u_Width,
				u_Kvmetr: item.u_Kvmetr,
				u_FigureQuantity: item.u_FigureQuantity,
				u_PlannedQuantity:
					item?.itemCode === 'stanokk_xarajat' ||
					item?.itemCode === 'Elektr_xarajat'
						? totalShippingQty / item.u_PlannedQuantity
						: totalSendingQty,
											isProduct: false,
orderQuantity: item.quantity
			}
		})

		const documentLinesItems = itemDocLines
			.filter(
				(item) =>
					roundToTwoDecimals(
						item.oneItemKvm * item.shippingQuantity,
					) > 0,
			)
			.map((item, idx) => {
				return {
					baseEntry: baseEntry,
					baseLine: item.lineNum,
					baseType: data?.correctionDocEntry ? 165 : 13,
					itemCode: item.itemCode,
					quantity: roundToTwoDecimals(
						item.oneItemKvm * item.shippingQuantity,
					),
					lineNum: getNextLineNum(),
					price: item.price,
					currency: item.currency,
					warehouseCode: item.warehouseCode || '',
					u_Coefficient: item.u_Coefficient,
					u_Height: item.u_Height,
					u_Width: item.u_Width,
					u_Kvmetr: item.shippingQuantity,
					u_FigureQuantity: item.u_FigureQuantity,
					u_PlannedQuantity: item.shippingQuantity,
					isProduct: true,
orderQuantity: item.quantity
				}
			})

		const potsLinesUpdate = itemDocLines
			?.filter((item) => item.productions?.length > 0)
			.flatMap((item) =>
				item.productions.map((production) => ({
					code: production,
				})),
			)

		const docLinesForDocTotal = [
			...documentLinesItems,
			...documentLinesServices?.filter(
				(item) => item.itemCode !== 'delivery',
			),
			// ...expensesLines, // Bu DocTotalga berilishi kerak emas
		]
		const docTotal = docLinesForDocTotal.reduce((acc, item) => {
			acc += item.quantity * item.price
			return acc
		}, 0)

		// console.log('docTotal', docTotal, 'docLines', docLinesForDocTotal,"itemDocLines",itemDocLines,)

		const postingData = [
			{
				cardCode: data?.cardCode,
				documentsOwner: employeeId,
				salesPersonCode: salesPersonCode,
				docCurrency: data?.docCurrency,
				department: data?.u_Department,
				docTotal: docTotal,
				documentLines: [
					...documentLinesItems,
					...documentLinesServices,
					...expensesLines,
				],
				potsLinesUpdate,
			},
		]

		console.log('postingData', postingData, itemDocLines)

		setShipBtnLoading(true)

		try {
			await http.post(`api/sales/sotuvga-nusxalash/batch`, postingData)
			onClose()
			refetch()

			successRef.current.open(t('sucCreated'))
		} catch (error) {
			errorRef.current.open(error?.response?.data?.message)
		} finally {
			setShipBtnLoading(false)
		}
	}

	const startProduction = async () => {
		setStartProductionBtnLoading(true)

		try {
			await http.post(`api/pots/allow-production/${data?.docEntry}`, {})
			onClose?.()
			refetch?.()
			successRef.current.open(t('sucChanged'))
		} catch (error) {
			errorRef.current.open(error?.response?.data?.message)
		} finally {
			setStartProductionBtnLoading(false)
		}
	}


	if (!data) return null

	const columns = [
		{
			title: t('item'),
			dataIndex: 'itemDescription',
			key: 'itemDescription',
			width: 200,
			render: (text, record, index) => {
				return <span>{text}</span>
			},
		},
		{
			title: t('size'),
			dataIndex: 'width',
			key: 'size',
			width: 150,
			render: (text, record, index) => {
				const width = new Intl.NumberFormat('fr-FR').format(text)
				const height = new Intl.NumberFormat('fr-FR').format(
					record.height,
				)
				return (
					<span>
						{width} X {height}
					</span>
				)
			},
		},
		{
			title: `${t('quantity')} `,
			dataIndex: 'u_PlannedQuantity',
			key: 'u_PlannedQuantity',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span> {formattedText}</span>
			},
		},
		{
			title: `${t('openQty')}  (${t('sht')})`,
			dataIndex: 'openQuantitySon',
			key: 'openQuantitySon',
			width: 150,

		},
		{
			title: `${t('shippedQuantity')}  (${t('sht')})`,
			dataIndex: 'shippedQuantity',
			key: 'shippedQuantity',
			render: (text) => {
				return <span>{numberWithSpacesIntl(text)}</span>
			},
		},
		// {
		// 	title: `${t('shippingQuantity')}  (${t('sht')})`,
		// 	dataIndex: 'shippingQuantity',
		// 	key: 'shippingQuantity',
		// 	render: (text) => {
		// 		return <span>{numberWithSpacesIntl(text)}</span>
		// 	},
		// },
		{
			title: t('serialNumbers'),
			dataIndex: 'productions',
			key: 'productions',
			render: (text, record, index) => {
				const productionsForThisItem = productionData?.filter(
					(item) => item.u_uslugaID == record.lineNum,
				)

				const options = productionsForThisItem?.map((item, index) => ({
					value: item.code,
					label: item.serialNumber,
					key: index,
				}))

				return (
					<Select
						options={options}
						mode="multiple"
						disabled={!ship}
						value={record?.productions}
						className="w-[200px]"
						onChange={(val) => {
							const newItemDocLines = [...itemDocLines]
							newItemDocLines[index].productions = val
							newItemDocLines[index].shippingQuantity = val.length
							setItemDocLines(newItemDocLines)
						}}
					/>
				)
			},
		},
		{
			title: t('shippingQuantity') + '  (' + t('sht') + ')',
			dataIndex: 'shippingQuantity',
			key: 'shippingQuantity',

			render: (text, record, index) => {
				const productionsForThisItem = productionData?.filter(
					(item) => item.u_uslugaID == record.lineNum,
				)

				return (
				<div className="flex items-center gap-2 justify-center">

						<Input
						type="text"
						disabled={!productionsForThisItem?.length}
						value={record?.shippingQuantity}
						max={productionsForThisItem?.length || 0}
						min={0}
						// suffix={}
						className="w-[120px]"
						onChange={(e) => {
							const newItemDocLines = [...itemDocLines]
							const quantity = parseInt(e.target.value) || 0
							const validQuantity = Math.min(
								quantity,
								productionsForThisItem?.length || 0,
							)

							// Auto-select first N productions based on quantity
							const selectedProductions = productionsForThisItem
								?.slice(0, validQuantity)
								?.map((item) => item.code) || []

							newItemDocLines[index].productions =
								selectedProductions
							newItemDocLines[index].shippingQuantity =
								validQuantity
							setItemDocLines(newItemDocLines)
						}}
					/>
			<Tag color="blue">
					{t("max")}: {productionsForThisItem?.length || 0}
						</Tag>
				</div>
				)
			},
		},
		{
			title: t('kv.m'),
			dataIndex: 'quantity',
			key: 'quantity',
			render: (text, ) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span> {formattedText}</span>
			},
		},
		{
			title: `${t('openQty')} (${t('kv.m')})`,
			dataIndex: 'openQty',
			key: 'openQty',

			render: (text, record, index) => {
				const formattedText = numberWithSpacesIntl(text)
				return <span> {formattedText}</span>
			},
		},
		{
			title: `${t('shippedQuantity')}  (${t('kv.m')})`,
			dataIndex: 'shippedQuantityKvm',
			key: 'shippedQuantityKvm',
			render: (text, record, index) => {
				const formattedText = numberWithSpacesIntl(text)
				return <span> {formattedText}</span>
			},
		},

		{
			title: t('Koefitsent'),
			dataIndex: 'koef',
			key: 'koef',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span>{formattedText}</span>
			},
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},

		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},
		...(getMe.jobTitle === 'admin'
			? [
					{
						title: t('whs'),
						dataIndex: 'whsName',
						key: 'whsName',
						width: 150,
						render: (text, record, index) => <span>{text}</span>,
					},
				]
			: []),
	]


	const finishedSalesColumns = [
		{
			title: t('item'),
			dataIndex: 'itemDescription',
			key: 'itemDescription',
			width: 150,
			render: (text, record, index) => {
				return <span>{text}</span>
			},
		},
		{
			title: t('size'),
			dataIndex: 'width',
			key: 'size',
			width: 150,
			render: (text, record, index) => {
				const width = new Intl.NumberFormat('fr-FR').format(text)
				const height = new Intl.NumberFormat('fr-FR').format(
					record.height,
				)
				return (
					<span>
						{width} X {height}
					</span>
				)
			},
		},
		{
			title: `${t('shippedQuantity')} `,
			dataIndex: 'u_PlannedQuantity',
			key: 'u_PlannedQuantity',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span> {formattedText}</span>
			},
		},

		{
			title: `${t('shippedQuantity')}  (${t('kv.m')})`,
			dataIndex: 'quantity',
			key: 'quantity',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span> {formattedText}</span>
			},
		},

		{
			title: t('Koefitsent'),
			dataIndex: 'koef',
			key: 'koef',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span>{formattedText}</span>
			},
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},

		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},
		...(getMe.jobTitle === 'admin'
			? [
					{
						title: t('whs'),
						dataIndex: 'whsName',
						key: 'whsName',
						width: 150,
						render: (text, record, index) => <span>{text}</span>,
					},
				]
			: []),
	]

	const columnsServices = [
		{
			title: t('service'),
			dataIndex: 'itemDescription',
			key: 'itemDescription',
			width: 150,
			render: (text, record) => {
				return (
					<span>
						<span className="font-bold">
							{record.u_Number ? `${record.u_Number} ` : ''}
						</span>
						{text}
					</span>
				)
			},
		},

		{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span> {formattedText}</span>
			},
		},
		{
			title: t('openQty'),
			dataIndex: 'openQty',
			key: 'openQty',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span> {formattedText}</span>
			},
		},
		{
			title: t('shippedQuantity'),
			dataIndex: 'shippedQuantity',
			key: 'shippedQuantity',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					+record.quantity - +record.openQty,
				)
				return <span> {formattedText}</span>
			},
		},
		{
			title: t('unitMsr'),
			dataIndex: 'ugpCode',
			key: 'ugpCode',
			render: (text, record, index) => {
				return (
					<span>
						{text !== null
							? record?.itemDescription?.includes('GRAVIROVKA')
								? 'м'
								: text
							: ''}
					</span>
				)
			},
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},

		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					record.quantity * record.price,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},
		{
			title: t('u_Produkt'),
			dataIndex: 'u_Produkt',
			key: 'u_Produkt',
			render: (text, record, index) => {
				const item = itemDocLines?.find(
					(item) => item.lineNum == record.u_uslugaID,
				)
				return <span>{text}  {item?.width} x {item?.height}</span>
			},
		},
	]
	const columnsWorkerKpi = [
		{
			title: t('service'),
			dataIndex: 'itemDescription',
			key: 'itemDescription',
			render: (text, record) => {
				return (
					<span>
						<span className="font-bold">
							{record.u_Number ? `${record.u_Number} ` : ''}
						</span>
						{text}
					</span>
				)
			},
		},


		{
			title: t('price'),
			dataIndex: 'quantity',
			key: 'quantity2',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					record.workerSalaries ? record.workerSalaries / record.quantity : '' ,
				)
	return (
					<span>
						{formattedText} {record.currency}
					</span>
				)			},
		},

{
			title: t('quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span> {formattedText}</span>
			},
		},
		{
			title: t('workerSalaries'),
			dataIndex: 'workerSalaries',
			key: 'workerSalaries',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
				text,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},
		// {
		// 	title: t('u_Produkt'),
		// 	dataIndex: 'u_Produkt',
		// 	key: 'u_Produkt',
		// 	render: (text, record, index) => {
		// 		const item = itemDocLines?.find(
		// 			(item) => item.lineNum == record.u_uslugaID,
		// 		)
		// 		return <span>{text}  {item?.width} x {item?.height}</span>
		// 	},
		// },
	]

		const columnsExpenses = [
		{
			title: t('expense'),
			dataIndex: 'itemDescription',
			key: 'itemDescription',
			render: (text, record) => {
				return (
					<span>
						<span className="font-bold">
							{record.u_Number ? `${record.u_Number} ` : ''}
						</span>
						{text}
					</span>
				)
			},
		},

		{
			title: t('total'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text * record.quantity,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},
	]


	const finishedServicesColumns = [
		{
			title: t('service'),
			dataIndex: 'itemDescription',
			key: 'itemDescription',
			width: 150,
			render: (text, record) => {
				return (
					<span>
						<span className="font-bold">
							{record.u_Number ? `${record.u_Number} ` : ''}
						</span>
						{text}
					</span>
				)
			},
		},

		{
			title: t('shippedQuantity'),
			dataIndex: 'quantity',
			key: 'quantity',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span> {formattedText}</span>
			},
		},

		{
			title: t('unitMsr'),
			dataIndex: 'ugpCode',
			key: 'ugpCode',
			render: (text, record, index) => {
				return (
					<span>
						{text !== null
							? record?.itemDescription?.includes('GRAVIROVKA')
								? 'м'
								: text
							: ''}
					</span>
				)
			},
		},

		{
			title: t('price'),
			dataIndex: 'price',
			key: 'price',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},

		{
			title: t('totalMiqdor'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					record.quantity * record.price,
				)
				return (
					<span>
						{formattedText} {record.currency}
					</span>
				)
			},
		},
		{
			title: t('u_Produkt'),
			dataIndex: 'u_Produkt',
			key: 'u_Produkt',
		},
	]



	const tableDataServices = data?.documentLines
		.filter((item) => {
			return (
				item.u_Produkt !== null &&
				item.u_ItemGroup !== 'Chizma' &&
				item.u_Modal !== 'Xarajatlar'
			)
		})
		.map((item, index) => ({
			...item,
			key: index,
			itemDescription: item.itemDescription,
			quantity: item.quantity,
			price: item.price,
			lineTotal: item.lineTotal,
			whsName: item.whsName,
			u_Produkt: item.u_Produkt,
			currency: item.currency,
			openQty: item.openQty,
			ugpCode: item.ugpCode,
			u_PlannedQuantity: item.u_PlannedQuantity,
			u_Number: item.u_Number,
		}))

	const tableDataExpenses = data?.documentLines.filter((item) => {
		return item.u_Modal == 'Xarajatlar'
	})

	return (
		<div className="w-full px-4 ">
			<div className="w-full">
				<div className="mt-10 flex flex-col items-center justify-between sm:flex-row">
					<div className="flex flex-col gap-3">
						<p className="font-bold">{t('mijoz')}</p>
						<Input
							type="text"
							value={data.cardName}
							className="flex w-[200px] items-center justify-center sm:w-[250px]"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('status')}</p>
						<Input
							value={data?.u_AbsoluteStatus}
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('currency')}</p>
						<Input
							value={data.docCurrency}
							style={{ color: 'black' }}
							disabled
						/>
					</div>

					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('date')}</p>
						<Input
							type="text"
							value={dueDate}
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="mt-4 flex flex-col gap-3 sm:mt-0">
						<p className="font-bold">{t('deadLine2')}</p>
						<Input
							type="text"
							value={deadLine}
							style={{ color: 'black' }}
							disabled
						/>
					</div>

				</div>

				<div className="mt-12">
					<p className="font-bold text-center">{t('items')}</p>
					<Table
						columns={
							isFinishedSalesMenu ? finishedSalesColumns : columns
						}
						dataSource={itemDocLines}
						pagination={false}
						className="border-1 mt-5  border-black"
						scroll={{ x: isFinishedSalesMenu ? '100%' : '1600px' }}
						bordered
					/>
				</div>

				<div className="mt-12">
					<p className="font-bold text-center">{t('services')}</p>
					<Table
						columns={
							isFinishedSalesMenu
								? finishedServicesColumns
								: columnsServices
						}
						dataSource={tableDataServices}
						pagination={false}
						className="border-1 mt-5 border-black"
						scroll={{ x: '100%' }}
						bordered
					/>
				</div>
		{isShowProfit && 		<div className="mt-12">
					<p className="font-bold text-center">{t('expenses')}</p>
					<Table
						columns={columnsExpenses}
						dataSource={tableDataExpenses}
						pagination={false}
						className="border-1 mt-5 border-black"
						scroll={{ x: '100%' }}
						bordered
						summary={(pageData) => {
							const totalExpenses = pageData.reduce(
								(acc, item) => acc + item.price * item.quantity,
								0,
							)
							const currency = pageData[0]?.currency || ''
							return (
								<Table.Summary fixed>
									<Table.Summary.Row>
										<Table.Summary.Cell index={0}>
											<span className="font-bold">{t('total')}</span>
										</Table.Summary.Cell>
										<Table.Summary.Cell index={1}>
											<span className="font-bold">
												{new Intl.NumberFormat('fr-FR').format(totalExpenses)} {currency}
											</span>
										</Table.Summary.Cell>
									</Table.Summary.Row>
								</Table.Summary>
							)
						}}
					/>
				</div>}

				{isShowProfit && 	<div className="mt-12">
					<p className="font-bold text-center">{t('workerSalaries')}</p>
					<Table
						columns={columnsWorkerKpi}
						dataSource={tableDataServices}
						pagination={false}
						className="border-1 mt-5 border-black"
						scroll={{ x: '100%' }}
						bordered
						summary={(pageData) => {
							const totalQuantity = pageData.reduce(
								(acc, item) => acc + (+item.quantity || 0),
								0,
							)
							const totalSalaries = pageData.reduce(
								(acc, item) => acc + (+item.workerSalaries || 0),
								0,
							)
							const currency = pageData[0]?.currency || ''
							return (
								<Table.Summary fixed>
									<Table.Summary.Row>
										<Table.Summary.Cell index={0}>
											<span className="font-bold">{t('total')}</span>
										</Table.Summary.Cell>
										<Table.Summary.Cell index={1} />
										<Table.Summary.Cell index={2}>
											<span className="font-bold">
												{new Intl.NumberFormat('fr-FR').format(totalQuantity)}
											</span>
										</Table.Summary.Cell>
										<Table.Summary.Cell index={3}>
											<span className="font-bold">
												{new Intl.NumberFormat('fr-FR').format(totalSalaries)} {currency}
											</span>
										</Table.Summary.Cell>
									</Table.Summary.Row>
								</Table.Summary>
							)
						}}
					/>
				</div>}

				<div className="w-full flex items-center justify-between mt-5  ">
					<div className="flex items-center gap-3 ">
						<p className="font-bold">{t('totalForDocument')}:</p>
						<Input
							type="text"
							value={`${new Intl.NumberFormat('fr-FR').format(data.docTotal)} ${data.docCurrency}`}
							className="flex h-8 w-[70px] items-center justify-center sm:w-[250px]"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="flex items-center gap-3 ">
						<p className="font-bold">{t('comments')}:</p>
						<Input.TextArea
							type="text"
							value={data.comments}
							className="flex h-8 w-[70px] items-center justify-center sm:w-[250px]"
							style={{ color: 'black' }}
							disabled
						/>
					</div>
				</div>

				<div className="flex items-center justify-end gap-3 mt-10">
					{incoming ? (
						<Button
							onClick={() => {
								setIsModalVisible(true)
							}}
							className="h-[30px] w-[140px]  bg-[#0A4D68] rounded-lg text-white "
						>
							{t('pay')}
						</Button>
					) : (
						''
					)}
					{isShowStartProduction ? (
						<Button
							onClick={startProduction}
							loading={startProductionBtnLoading}
							className="h-[30px]   bg-[#0A4D68] rounded-lg text-white "
						>
							{t('allowProduction')}
						</Button>
					) : (
						''
					)}
					{ship ? (
						<Button
							onClick={shipData}
							loading={shipBtnLoading}
							// disabled={data.docTotal - data.paidToDate <= 0}
							className="h-[30px]   bg-[#0A4D68] rounded-lg text-white "
						>
							{t('finishSale')}
						</Button>
					) : (
						''
					)}
					{finishSale ? (
						<Button
							onClick={shipData}

							disabled={!data || data.length === 0}
							className="h-[30px] w-auto  bg-[#0A4D68] rounded-lg text-white "
						>
							{t('finishSale')}
						</Button>
					) : (
						''
					)}
				</div>
			</div>

			<OrderPaymentModal
				visible={isModalVisible}
				data={data}
				onClose={() => setIsModalVisible(false)}
			/>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</div>
	)
}

export default SalesInfo
